import { render, staticRenderFns } from "./EditReportCategory.vue?vue&type=template&id=7a6cd4fc&scoped=true"
import script from "./EditReportCategory.vue?vue&type=script&lang=js"
export * from "./EditReportCategory.vue?vue&type=script&lang=js"
import style0 from "./EditReportCategory.vue?vue&type=style&index=0&id=7a6cd4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6cd4fc",
  null
  
)

export default component.exports